import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const FAQS = [
  {
    q: "Who do you typically train?",
    a: "Corporate teams (managers, ICs, entire departments), students at educational institutes, and one-on-one professionals preparing for interviews, leadership roles or public speaking.",
  },
  {
    q: "Are sessions available online?",
    a: "Yes. Every workshop can be delivered virtually (Zoom / Google Meet / Teams) or in-person. Blended formats are also available for large teams.",
  },
  {
    q: "Is the POSH training compliance-ready?",
    a: "Yes. Ruchika is a Certified POSH Trainer. Sessions cover the PoSH Act, IC responsibilities, case walk-throughs and behaviour setting for a safer workplace.",
  },
  {
    q: "How do payments work?",
    a: "Individual workshop seats are paid via Razorpay (cards, UPI, netbanking, wallets). Corporate engagements are invoiced against a purchase order.",
  },
  {
    q: "Can workshops be customised?",
    a: "Absolutely. Every corporate engagement begins with a scoping call to align on outcomes, participants and delivery format.",
  },
  {
    q: "Where are you based and do you travel?",
    a: "Based in India. Sessions are delivered pan-India in-person, and globally over video for remote teams.",
  },
];

export const FAQ = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="border-b border-black/10 bg-white"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-10 py-20 md:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <div className="overline mb-3">FAQ</div>
            <h2 className="font-display text-4xl md:text-5xl text-black leading-[0.98]">
              Answers,
              <br />
              before you ask.
            </h2>
            <p className="mt-6 text-neutral-700 text-sm md:text-base max-w-sm">
              Still curious? Drop a note in the contact form — we usually reply
              within a business day.
            </p>
          </div>

          <div className="lg:col-span-8">
            <Accordion
              type="single"
              collapsible
              className="border-t border-black"
              data-testid="faq-accordion"
            >
              {FAQS.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  className="border-b border-black"
                >
                  <AccordionTrigger
                    data-testid={`faq-trigger-${i}`}
                    className="text-left font-display text-lg md:text-xl text-black py-6 hover:no-underline"
                  >
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent
                    data-testid={`faq-content-${i}`}
                    className="text-neutral-700 text-sm md:text-base leading-relaxed pb-6"
                  >
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
